import winston from 'winston';
import WinstonCloudWatch from 'winston-cloudwatch';
import AWS from 'aws-sdk';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import logLevelEnum from '../enums/logLevelEnum';

AWS.config.update({
  region: process.env.REACT_APP_REGION,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  }),
});

export const winstonInit = (userName) => {
  const getFormattedDate = () => moment().format('YYYY/MM/DD');
  const newUUID = userName ? `user-${userName}` : uuidv4();
  winston.add(
    new WinstonCloudWatch({
      cloudWatchLogs: new AWS.CloudWatchLogs(),
      logGroupName: `${process.env.REACT_APP_APPLICATION_NAME}-${process.env.REACT_APP_ENV}`,
      logStreamName: `${getFormattedDate()}/${newUUID}`,
    }),
  );
  if (window?.BASELINE) window.BASELINE.winston = winston;
};

const messageFormatter = (data, logLevel, uuid) => {
  return JSON.stringify({
    logLevel: `[${logLevel}]`,
    message: data,
    id: uuid,
    stackTrace: new Error().stack,
  });
};

const logger = {
  info: (data) => {
    if (process.env.REACT_APP_LOGS === 'console') {
      console.info(data);
    } else if (process.env.REACT_APP_LOGS === 'none') {
      return;
    } else {
      const uuid = uuidv4();
      console.info(`info is generated and it has been logged with this id: ${uuid} `);
      window?.BASELINE?.winston?.info(messageFormatter(data, logLevelEnum.INFO, uuid));
    }
  },
  error: (data) => {
    if (process.env.REACT_APP_LOGS === 'console') {
      console.error(data);
    } else if (process.env.REACT_APP_LOGS === 'none') {
      return;
    } else {
      window.setImmediate = window.setTimeout;
      const uuid = uuidv4();
      console.info(`error has been found and it has been logged with this id: ${uuid} `);
      window?.BASELINE?.winston?.error(messageFormatter(data, logLevelEnum.ERROR, uuid));
    }
  },
  debug: (data) => {
    if (process.env.REACT_APP_LOGS === 'console') {
      console.debug(data);
    } else if (process.env.REACT_APP_LOGS === 'none') {
      return;
    } else {
      const uuid = uuidv4();
      console.info(`debug message is generated and it has been logged with this id: ${uuid} `);
      window?.BASELINE?.winston?.debug(messageFormatter(data, logLevelEnum.DEBUG, uuid));
    }
  },
  warn: (data) => {
    if (process.env.REACT_APP_LOGS === 'console') {
      console.warn(data);
    } else if (process.env.REACT_APP_LOGS === 'none') {
      return;
    } else {
      const uuid = uuidv4();
      console.info(`warn message is generated and it has been logged with this id: ${uuid}`);
      window?.BASELINE?.winston?.warn(messageFormatter(data, logLevelEnum.WARN, uuid));
    }
  },
};

export default logger;
